import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { brandColors } from "../../theme";

export const ACCENT_PALETTE = [
  { name: "Electric Blue", value: brandColors.electricBlue },
  { name: "Coral",         value: brandColors.coral },
  { name: "Lime",          value: brandColors.limeGreen },
  { name: "Violet",        value: brandColors.vividViolet },
];

const STORAGE_KEY    = "chalkitup.sidebarAccent";
const DEFAULT_ACCENT = brandColors.electricBlue;

const SidebarAccentContext = createContext({
  accent:    DEFAULT_ACCENT,
  setAccent: () => {},
  palette:   ACCENT_PALETTE,
  minimized: false,
});

export function SidebarAccentProvider({ children, minimized = false }) {
  const [accent, setAccentState] = useState(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      return stored && stored.startsWith("#") ? stored : DEFAULT_ACCENT;
    } catch {
      return DEFAULT_ACCENT;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, accent);
      window.dispatchEvent(new CustomEvent("chalkitup:accent", { detail: accent }));
    } catch { /* ignore */ }
  }, [accent]);

  const setAccent = useCallback((value) => setAccentState(value), []);

  const value = useMemo(
    () => ({ accent, setAccent, palette: ACCENT_PALETTE, minimized }),
    [accent, setAccent, minimized],
  );

  return (
    <SidebarAccentContext.Provider value={value}>
      {children}
    </SidebarAccentContext.Provider>
  );
}

export function useSidebarAccent() {
  return useContext(SidebarAccentContext);
}

export default SidebarAccentContext;
